export default "__VITE_ASSET__CtJriQa9__"